import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import {
  HeaderBanner,
  VenteBanner,
  MecaBanner,
  AnalysesBanner,
} from '../Main/services';

import ContactUs from '../Footer/ContactUs';

const Services = ({ data }) => {
  const mecaList = data.mecaBannerNav;
  const dataList = [
    {
      id: mecaList[0],
      content: data.mecaBannerDepannageContent.childMarkdownRemark.html,
      image: data.mecaBannerDepannageImage,
    },
    {
      id: mecaList[1],
      content: data.mecaBannerGarantieContent.childMarkdownRemark.html,
      image: data.mecaBannerGarantieImage,
    },
    {
      id: mecaList[2],
      content: data.mecaBannerMaintenanceContent.childMarkdownRemark.html,
      image: data.mecaBannerMaintenanceImage,
    },
    {
      id: mecaList[3],
      content: data.mecaBannerAmeliorationContent.childMarkdownRemark.html,
      image: data.mecaBannerAmeliorationImage,
    },
    {
      id: mecaList[4],
      content: data.mecaBannerRevisionContent.childMarkdownRemark.html,
      image: data.mecaBannerRevisionImage,
    },
    {
      id: mecaList[5],
      content: data.mecaBannerProtectionContent.childMarkdownRemark.html,
      image: data.mecaBannerProtectionImage,
    },
  ];

  const hreflang = data.node_locale === 'fr' ? 'en' : 'fr';

  return (
    <div className="services">
      <Helmet>
        <html lang={data.node_locale} />
        <title>{`Offshore Services - ${data.title}`}</title>
        <meta name="description" content={data.metaDescription} />
        <link
          rel="alternate"
          hreflang={hreflang}
          href={`https://www.offshoreservices.fr/${hreflang}/services/`}
        />
      </Helmet>
      <HeaderBanner title={data.title} image={data.headerImage} />
      <VenteBanner
        title={data.venteBannerTitle}
        image={data.venteBannerImage}
        content={data.venteBannerContent.childMarkdownRemark.html}
      />
      <MecaBanner title={data.mecaBannerTitle} dataList={dataList} />
      <AnalysesBanner
        title={data.analysesBannerTitle}
        analysesList={data.analysesBannerList}
        analysesListIcon={data.analysesBannerListIcon}
      />
      <ContactUs locale={data.node_locale} />
    </div>
  );
};

export default Services;



// WEBPACK FOOTER //
// ./src/components/Pages/Services.js